import { TThunkAction } from 'shared/types/redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { selectSearchMetaData } from 'shared/selectors/searchMeta';
import { selectLocation } from 'shared/selectors/location';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { updateLastAppliedFilter } from 'shared/slices/searchMetaTooltip';
import { UXFB_CLIENT_EVENTS_CONFIG_KEY, UXFB_EVENT_SERP_FILTER_APPLIED } from 'shared/constants/uxfb';
import { EPageType } from 'shared/types/page';
import { dispatchFiltersUpdatedEvent } from 'shared/utils/event';
import { getSerpFilterAppliedAttributes, getViewMode, sendUXSEventWhenReady } from 'shared/utils/uxs';

export const applyFilters = (): TThunkAction => (dispatch, getState, context) => {
  const state = getState();

  const jsonQuery = selectJsonQuery(state);
  const searchMeta = selectSearchMetaData(state);
  const location = selectLocation(state);
  const pageType = selectPageType(state);

  if (!jsonQuery || !searchMeta || !location) {
    return;
  }

  dispatchFiltersUpdatedEvent({ jsonQuery, searchMeta, location });

  /**
   * UXFB-событие применения фильтра (SEL-873): шлём только на выдаче (на главных заход посчитает
   * `search_listing`). Kill-switch — молчим только при явном `false` в конфиге.
   * Легаси-эстафета updateLocalStorageFiltersWereApplied живёт параллельно и не трогается.
   */
  if (
    (pageType === EPageType.SEARCH || pageType === EPageType.SEARCH_RENT_DAILY) &&
    context.config.get<boolean>(UXFB_CLIENT_EVENTS_CONFIG_KEY) !== false
  ) {
    sendUXSEventWhenReady(
      UXFB_EVENT_SERP_FILTER_APPLIED,
      getSerpFilterAppliedAttributes({
        jsonQuery,
        deviceType: context.custom.initialDeviceType,
        viewMode: getViewMode(window.location.pathname),
        pageType,
      }),
    );
  }

  dispatch(updateLastAppliedFilter(null));
};
